import { useShowNotification } from '@inflearn/ds-react-next';
import { useQueryClient } from '@tanstack/react-query';

import { useTranslation } from 'next-i18next';
import { API_ENDPOINT } from '../../resources/@types/apiEndpoint';
import {
  ResponseStatus,
  useClientApiV1UsersUserIdIntroduceUpdateMutation,
} from '../../resources/@types/uccSchema';
import { ApiError } from '../../resources/ApiError';
import { getUseUserProfileQueryKey } from './useUserProfileQuery';

export function useUpdateIntroduce(userId: number) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { showNotification } = useShowNotification();

  return useClientApiV1UsersUserIdIntroduceUpdateMutation({
    url: API_ENDPOINT.CLIENT_V1_USERS_USERID_INTRODUCE(String(userId)),
    options: {
      onSuccess: () => {
        void queryClient.invalidateQueries({
          queryKey: getUseUserProfileQueryKey(userId),
        });
      },
      onError: (error) => {
        if (!(error instanceof ApiError)) {
          return;
        }

        if (error.statusCode === ResponseStatus.FORBIDDEN) {
          showNotification({
            type: 'error',
            title: t('해당 프로필 유저가 아닙니다.'),
          });
        }
      },
    },
  });
}
